<div class="main-container">
    <div class="filter-section mat-elevation-z8">
        <app-analytics-filter (filterEmit)="fetchData($event)" />
    </div>
    <div class="analytics-section mat-elevation-z8">
        <h1>
            Analytics
        </h1>

        @if (isLoadingResults) {
        <div class="loading-shade">
            <mat-spinner></mat-spinner>
        </div>
        }
        <div class="graph-container" [hidden]="!this.resultsLength">
            <div class="flex-col">
                <h2>
                    Simple Statistics
                </h2>
                <div class="flex-row">
                    <div class="flex-col">
                        <app-tile id="number-tile" [title]="'Total Interventions'" [count]="resultsLength"></app-tile>
                        <app-tile id="downtime-tile" [title]="'Total Downtime [min]'"
                            [count]="getTotalDowntime(tableData.data)"></app-tile>
                    </div>
                    <app-bar-chart id="intervention-bar" [data]="tableData.data" [keys]="barChartKeys"></app-bar-chart>
                </div>
                <div class="flex-col" style="width: max(400px, min(800px, 70%)); text-align: center;">
                    <br />
                    <h2>
                        Summary of Deviations
                    </h2>
                    <p>
                        Below is a summary of the deviations reported for the given query.
                        You can use this as a "Top X" list where you can sort on number of reports and downtime.
                    </p>
                    <p>
                        <strong>NOTE:</strong> Interventions without a linked deviation ticket will <strong>not</strong>
                        appear in this table
                    </p>
                </div>
                <div class="table-container">
                    <app-deviation-table [tableData]="deviationSummaryData"></app-deviation-table>
                </div>
                <h2>
                    All Reported Interventions
                </h2>
                <div class="table-container mat-elevation-z2">

                    <table id="interventions-table" mat-table [dataSource]="tableData" class="table-colors" matSort
                        matSortActive="date" matSortDisableClear matSortDirection="desc">
                        <!-- Date Column -->
                        <ng-container matColumnDef="date" class="date-cell">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Date</th>
                            <td mat-cell *matCellDef="let row">{{ row.timestamp | date: 'yyyy-MM-dd HH:mm:ss' }}</td>
                        </ng-container>

                        <!-- Description Column -->
                        <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef>Description</th>
                            <td mat-cell *matCellDef="let row">{{row.description}}</td>
                        </ng-container>

                        <!-- Actions Column -->
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef>Actions</th>
                            <td mat-cell *matCellDef="let row">{{row.actions}}</td>
                        </ng-container>

                        <!-- Customer Column -->
                        <ng-container matColumnDef="customer">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Customer</th>
                            <td mat-cell *matCellDef="let row">{{row.customer}}</td>
                        </ng-container>

                        <!-- Usecase Column -->
                        <ng-container matColumnDef="usecase">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Usecase</th>
                            <td mat-cell *matCellDef="let row">{{row.usecase}}</td>
                        </ng-container>

                        <!-- Cart Column -->
                        <ng-container matColumnDef="cart">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Cart</th>
                            <td mat-cell *matCellDef="let row">{{row.cart}}</td>
                        </ng-container>

                        <!-- Reporter Column -->
                        <ng-container matColumnDef="reporter">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Reporter</th>
                            <td mat-cell *matCellDef="let row">{{row.reporter}}</td>
                        </ng-container>

                        <!-- Downtime Column -->
                        <ng-container matColumnDef="downtime">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Downtime</th>
                            <td mat-cell *matCellDef="let row">{{row.downtime}} min</td>
                        </ng-container>

                        <!-- Bug ID Column -->
                        <ng-container matColumnDef="bugId">
                            <th mat-header-cell mat-sort-header *matHeaderCellDef>Ticket ID</th>
                            <td mat-cell *matCellDef="let row">
                                <a [href]="'https://dev.azure.com/wheelme/' + adoProject + '/_workitems/edit/' + row.bugId"
                                    target="_blank">
                                    {{row.bugId}}
                                </a>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row (click)="openDialog(row) " *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator showFirstLastButtons [length]="this.resultsLength" [pageSize]="this.pageSize"
                        aria-label="Select page of intervention search results"></mat-paginator>
                </div>
            </div>
        </div>
        <p id="no-data-message" [hidden]="this.resultsLength">
            @if (hasBeenFetced && !isLoadingResults) {
            {{noDataQueryMessage}}
            } @else {
            {{noQueryRunsMessage}}
            }
        </p>
    </div>
</div>
